import React from 'react';
import { Tabs } from 'flowbite-react';
import Image from 'next/image';
import MWSVG from '@/components/common/svg';

const MachineLearningTechStack = () => {
    return (
        <div
            className="section-py bg-grey dark:bg-black overflow-x-hidden border-b"
            style={{
                borderImageSource: 'linear-gradient(270deg, rgba(60, 69, 97, 0) 0%, #3C4561 50%, rgba(60, 69, 97, 0) 100%)',
                borderImageSlice: 1,
            }}
        >
            <div className="container xl:container mx-auto">
                <div className="row grid lg:grid-cols-12 mb-11">
                    <div className="lg:col-span-12 text-center">
                        <h2 className="dark:text-white">Tech Stack</h2>
                    </div>
                </div>
                <div className="row grid lg:grid-cols-12 technologies-tools-tab overflow-x-hidden">
                    <div className="lg:col-span-12 grid">
                        <Tabs.Group className="items-center	tab-items" aria-label="underline tabs" style="underline">
                            <Tabs.Item active title="ML Frameworks">
                                <div className="row grid xl:grid-cols-6 lg:grid-cols-3 md:grid-cols-3 grid-cols-2">
                                    <div className="tech-box">
                                        <Image
                                            src="/img/python/svg/ic-tensorflow.svg"
                                            className="img-fluid mb-2.5"
                                            alt="TensorFlow"
                                            title="TensorFlow"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">TensorFlow</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/technologies-icon/pytorch.svg"
                                            className="img-fluid mb-2.5"
                                            alt="PyTorch"
                                            title="PyTorch"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">PyTorch</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/technologies-icon/scikit-learn.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Scikit-learn"
                                            title="Scikit-learn"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Scikit-learn</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/technologies-icon/img-xgboost.svg"
                                            className="img-fluid mb-2.5"
                                            alt="XGBoost"
                                            title="XGBoost"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">XGBoost</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/technologies-icon/lightgbm.svg"
                                            className="img-fluid mb-2.5"
                                            alt="LightGBM"
                                            title="LightGBM"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">LightGBM</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/technologies-icon/keras.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Keras"
                                            title="Keras"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Keras</p>
                                    </div>
                                </div>
                            </Tabs.Item>
                            <Tabs.Item title="Cloud ML Platforms">
                                <div className="row grid xl:grid-cols-4 lg:grid-cols-4 md:grid-cols-4 grid-cols-2">
                                    <div className="tech-box">
                                        <MWSVG id="ic-aws" svgClassName="!w-auto !h-[50px] mb-2.5" />
                                        <p className="text-base font-semibold mb-0 dark:text-white">AWS SageMaker</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/machine-learning/ic-azurML.svg"
                                            className="img-fluid mb-2.5 !h-10"
                                            alt="Azure ML"
                                            title="Azure ML"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Azure ML</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/machine-learning/ic-Vertex-AI.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Google Vertex AI"
                                            title="Google Vertex AI"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Google Vertex AI</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/machine-learning/ic-Databricks.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Databricks"
                                            title="Databricks"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Databricks</p>
                                    </div>
                                </div>
                            </Tabs.Item>
                            <Tabs.Item title="MLOps Tools">
                                <div className="row grid xl:grid-cols-5 lg:grid-cols-5 md:grid-cols-3 grid-cols-2">
                                    <div className="tech-box">
                                        <Image
                                            src="/img/vision-and-multimodal-ai/svg/ic-mlflow.svg"
                                            className="img-fluid mb-2.5"
                                            alt="MLflow"
                                            title="MLflow"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">MLflow</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/vision-and-multimodal-ai/svg/ic-kubeflow.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Kubeflow"
                                            title="Kubeflow"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Kubeflow</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/machine-learning/ic-dvc.svg"
                                            className="img-fluid mb-2.5"
                                            alt="DVC"
                                            title="DVC"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">DVC</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/machine-learning/ic-Weights-Biases.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Weights & Biases"
                                            title="Weights & Biases"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Weights & Biases</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/machine-learning/ic-Evidently-AI.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Evidently AI"
                                            title="Evidently AI"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Evidently AI</p>
                                    </div>
                                </div>
                            </Tabs.Item>
                            <Tabs.Item title="Data Processing Tools">
                                <div className="row grid xl:grid-cols-5 lg:grid-cols-5 md:grid-cols-3 grid-cols-2">
                                    <div className="tech-box">
                                        <Image
                                            src="/img/machine-learning/ic-pandas.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Pandas"
                                            title="Pandas"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Pandas</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/machine-learning/ic-numPy.svg"
                                            className="img-fluid mb-2.5"
                                            alt="NumPy"
                                            title="NumPy"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">NumPy</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/data-engineering-foundations/ic-apache-spark.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Apache Spark"
                                            title="Apache Spark"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Apache Spark</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/machine-learning/ic-dask.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Dask"
                                            title="Dask"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Dask</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/machine-learning/ic-polars.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Polars"
                                            title="Polars"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Polars</p>
                                    </div>
                                </div>
                            </Tabs.Item>
                            <Tabs.Item title="Model Serving Tools">
                                <div className="row grid xl:grid-cols-5 lg:grid-cols-5 md:grid-cols-3 grid-cols-2">
                                    <div className="tech-box">
                                        <Image
                                            src="/img/python/svg/ic-tensorflow.svg"
                                            className="img-fluid mb-2.5"
                                            alt="TensorFlow Serving"
                                            title="TensorFlow Serving"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">TensorFlow Serving</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/technologies-icon/torch.svg"
                                            className="img-fluid mb-2.5"
                                            alt="TorchServe"
                                            title="TorchServe"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">TorchServe</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/machine-learning/ic-FastAPI.svg"
                                            className="img-fluid mb-2.5"
                                            alt="FastAPI"
                                            title="FastAPI"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">FastAPI</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/machine-learning/ic-bentoML.svg"
                                            className="img-fluid mb-2.5"
                                            alt="BentoML"
                                            title="BentoML"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">BentoML</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/machine-learning/ic-Seldon-Core.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Seldon Core"
                                            title="Seldon Core"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Seldon Core</p>
                                    </div>
                                </div>
                            </Tabs.Item>
                            <Tabs.Item title="Monitoring Tools">
                                <div className="row grid xl:grid-cols-4 lg:grid-cols-4 md:grid-cols-4 grid-cols-2">
                                    <div className="tech-box">
                                        <Image
                                            src="/img/machine-learning/ic-arize.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Arize"
                                            title="Arize"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Arize</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/technologies-icon/ic-Grafana.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Grafana"
                                            title="Grafana"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Grafana</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/machine-learning/ic-prometheus.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Prometheus"
                                            title="Prometheus"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Prometheus</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/machine-learning/ic-Fiddler-AI.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Fiddler AI"
                                            title="Fiddler AI"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Fiddler AI</p>
                                    </div>
                                </div>
                            </Tabs.Item>
                        </Tabs.Group>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default MachineLearningTechStack;
